import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseApiService } from '../../../../shared/services/api';

@Injectable({
    providedIn: 'root'
})
export class CompanyinboxService {
    companyListScrollPosition = 0;
    isLoader = false;
    companyLoadedFlag = new BehaviorSubject(false);
    isLoading = false;
    resultPage = {
        IsNavigating: false,
        resultData: [],
        totalHumanVerifiedCount: 0,
        totalPendingVerifiedCount: 0,
        companySidebarData: null,
        contactsSortedBy: '',
        contactsSortedByDirection: ''
    };
    companyResultParams = {
        page: 1,
        pageSize: 0,
        resultCount: 0,
        totalCount: 0,
        humanVerified: 0,
        machineVerified: 0,
        totalCountAll: 0
    };
    companyInternational = new BehaviorSubject(0);
    isCompanyInternational = 0;
    totalCompanies;
    humanVerified;
    machineVerified;
    lastVerifiedStatus;
    companyPageNumber = 1;
    constructor(
        private readonly baseApiService: BaseApiService
    ) {
        this.companyInternational.subscribe((internationData) => this.isCompanyInternational = internationData);
    }

    getInboxIntelCompanies(ids, page, verifiedStatus) {
        this.lastVerifiedStatus = verifiedStatus;
        return this.baseApiService.get<any>(
            'service/contactcloud/inboxIntel/companies?externalPrincipalId=' + ids + '&page=' + page + '&verifiedStatus=' + verifiedStatus,
            {
                excludeImpersonate: true,
            }
        );
    }

    deleteInboxIntelCompanies(data) {
        return this.baseApiService.post('service/contactcloud/inboxIntel/deleteCompanies', data, { excludeImpersonate: true });
    }

    exportToSalesforce(body) {
        const data = { inboxIntelCompanyIds: body };
        return this.baseApiService.post('service/contactcloud/inboxIntel/savedCompaniesToSalesforce', data, { excludeImpersonate: true });
    }

    tagInboxIntelCompanies(body) {
        return this.baseApiService.post('service/contactcloud/inboxIntel/savedCompaniesToSalesIntel', body, { excludeImpersonate: true, showError: true });
    }
    deAuthorizeInboxIntel() {
        const param = sessionStorage.getItem('externalPrincipalId');
        return this.baseApiService.delete<any>('service/contactcloud/inboxIntel/deleteAccount?externalPrincipalId=' + param, {
            excludeImpersonate: true,
            showError: true,
        });
    }
}
